import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=521b1155"
import script from "./MiniStatistic.vue?vue&type=script&lang=js"
export * from "./MiniStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports